import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

interface ChartProps {
  data: Array<{
    name: string;
    value: number;
  }>;
}

const Chart: React.FC<ChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart
        data={data}
        margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
      >
        <CartesianGrid
          strokeDasharray="0"
          stroke="#C5CBD3"
          strokeWidth={0.5}
          horizontal={true}
          vertical={false}
        />
        <XAxis
          dataKey="name"
          axisLine={{ stroke: '#93989C', strokeWidth: 1 }}
          tickLine={false}
          tick={{
            fill: '#93989C',
            fontSize: 14,
            fontFamily: 'HT Mosafer Rounded, sans-serif',
            opacity: 0.6,
          }}
          dy={10}
        />
        <YAxis
          axisLine={{ stroke: '#93989C', strokeWidth: 1 }}
          tickLine={false}
          tick={{
            fill: '#93989C',
            fontSize: 14,
            fontFamily: 'HT Mosafer Rounded, sans-serif',
            opacity: 0.6,
          }}
          dx={-10}
        />
        <Bar
          dataKey="value"
          fill="#426A53"
          radius={[2, 2, 0, 0]}
          maxBarSize={28}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default Chart;


